export default "__VITE_ASSET__BdGavbtd__"